import '@/bootstrap';
import '@/plugins/i18n';
import Vue from 'vue';
import { router } from './router';
import VueRouter from 'vue-router';
import VueMq from 'vue-mq';
import VueLazyload from 'vue-lazyload';
import PortalVue from 'portal-vue';

import DynamicTemplateApp from '@/DynamicTemplateApp.vue';
import Rating from '@molecules/Rating/Rating.vue';
import BaseIcon from '@atoms/Icon/BaseIcon.vue';
import Typography from '@atoms/Text/Typography.vue';
import CtaButton from '@atoms/Button/CtaButton.vue';
import DefaultButton from '@atoms/Button/DefaultButton.vue';
import BaseImage from '@atoms/Image/BaseImage.vue';
import LoadingImage from '@images/img-placeholder.jpg';
import ErrorImage from '@images/img-placeholder.png';

import {
    DEFAULT_TRAFFIC_SOURCE,
    BOT_TRAFFIC_SOURCE,
    DEVICE_DETECTION_TYPE_DESKTOP,
    DEVICE_TYPE_DESKTOP,
    DEVICE_TYPE_MOBILE,
} from '@/constants';
import { getCategoryPageProps } from '@/helpers';

try {
    window['__host__']['interlinking_boxes'] =
        window['__host__']['gw_article_content']['interlinking_boxes'][0];
} catch (e) {
    window['__host__']['interlinking_boxes'] = [];
}

const trafficSource = window.__traffic_source__ || DEFAULT_TRAFFIC_SOURCE;
const dynamicProps = window.__dyanmic_template_props__;

Vue.prototype.$globalConstants = Object.freeze({
    host: window.__host__,
    template: window.__template__,
    components: {
        ...dynamicProps,
        ...getCategoryPageProps(dynamicProps),
    },
    isCrawler: trafficSource === BOT_TRAFFIC_SOURCE || window.__is_crawler__,
    userId: window.__user_id__,
    user: window.__user__,
    clickinId: window.__clId__,
    deviceType:
        DEVICE_DETECTION_TYPE_DESKTOP === window.__device_type__
            ? DEVICE_TYPE_DESKTOP
            : DEVICE_TYPE_MOBILE,
    imageUrl: process.env.VUE_APP_MEDIA_HOST,
});

Vue.prototype.$globalState = {
    trafficSource: window.__traffic_source__ || DEFAULT_TRAFFIC_SOURCE,
    fixedPosition: null,
};

Vue.config.productionTip = false;

Vue.prototype.$eventHub = new Vue();

window.Vue = require('vue');

Vue.use(VueRouter);

Vue.use(PortalVue);

Vue.use(VueMq, {
    breakpoints: {
        mobileSmall: 640,
        mobile: 768,
        tablet: 1024,
        desktopSmall: 1248,
        desktop: Infinity,
    },
});

Vue.component('Rating', Rating);
Vue.component('Typography', Typography);
Vue.component('CtaButton', CtaButton);
Vue.component('Icon', BaseIcon);
Vue.component('BaseImage', BaseImage);
Vue.component('DefaultButton', DefaultButton);

Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1,
    error: ErrorImage,
    loading: LoadingImage,
});

new Vue({
    render: (h) => h(DynamicTemplateApp),
    router,
}).$mount('#app');

window.addEventListener('load', function () {
    try {
        window['emitPageLoadComplete']();
    } catch (e) {
        console.log('emitPageLoadComplete missing');
    }
});
